import React from "react";
import { createSwitchNavigator } from "react-navigation";
import { createStackNavigator } from "react-navigation-stack";
import * as firebase from "firebase";
import firebaseConfig from "./config/firebase.json";
import store from "./config/config.json"

import i18n from 'i18n-js';
import {translations} from './config/translations';

import MenuScreen 	 from "./screens/MenuScreen";
import DetailsScreen from "./screens/DetailsScreen";
import AreaScreen 	 from "./screens/AreaScreen";
import SearchScreen 	   from "./screens/SearchScreen";
import BranchesScreen 	   from "./screens/BranchesScreen";
import BranchDetailsScreen from "./screens/BranchDetailsScreen";
import ScheduledScreen from "./screens/ScheduledScreen";
import StatusScreen from "./screens/StatusScreen";
import ReviewScreen from "./screens/ReviewScreen";
import CheckoutScreen from "./screens/CheckoutScreen";
import ConfirmScreen  from "./screens/ConfirmScreen";
import DeliveryScreen from "./screens/DeliveryScreen";
import StoryScreen	  from "./screens/StoryScreen";
import OrderScreen from "./screens/OrderScreen";
import SuccessScreen from "./screens/SuccessScreen";
import ReceiptScreen from "./screens/ReceiptScreen";
import PaymentScreen from "./screens/PaymentScreen";
import SplashScreen from "./screens/SplashScreen";
import FailureScreen from "./screens/FailureScreen";

import { I18nManager as RNI18nManager} from "react-native";
import { createBrowserApp } from '@react-navigation/web';

import { AppProvider } from "./utilities/AppContext"
import ShareScreen from "./screens/ShareScreen";
import OffersScreen from "./screens/OffersScreen";

import ReactPixel from 'react-facebook-pixel';


firebase.initializeApp(firebaseConfig);

const MenuStack = createStackNavigator({
	menu	: MenuScreen, 
	share	: ShareScreen,
	details: {
		screen: DetailsScreen,
		navigationOptions: {
			headerShown: false
		}
	},
	offers : OffersScreen,
	success	 : SuccessScreen, 
	scheduled: ScheduledScreen, 
	review	 : ReviewScreen, 
	checkout : CheckoutScreen,
	story	 : StoryScreen,
	confirm	 : ConfirmScreen,
	order	 : OrderScreen,
	receipt: ReceiptScreen,	
	area: AreaScreen,
	payment: PaymentScreen
});
MenuStack.navigationOptions = {
	headerShown: false
}

const SearchStack = createStackNavigator({
	search : SearchScreen,
	details: {
		screen: DetailsScreen,
		navigationOptions: {
			headerShown: false
		},
	  }
	}
);
SearchStack.navigationOptions = {
	headerShown: false
}

const BranchesStack = createStackNavigator({
	branches: BranchesScreen,
	branchDetails: {
		screen: BranchDetailsScreen,
		navigationOptions: {
			headerShown: false
		},
	  },
	  initialRouteName: "branches",
	}
);
BranchesStack.navigationOptions = {
	headerShown: false
}

const StatusStack = createStackNavigator({
	status: StatusScreen,
	receipt: ReceiptScreen,	
});
StatusStack.navigationOptions = {
	headerShown: false
}

const SuccessStack = createStackNavigator({
	success: SuccessScreen	
});
SuccessStack.navigationOptions = {
	headerShown: false
}

/*
const createApp = Platform.select({
	web: config => createBrowserApp(config),
	default: config => createAppContainer(config),
});*/

const MainContainer = createBrowserApp(
	createSwitchNavigator(
		{		
			splash	: SplashScreen,		
			menu	: MenuStack,
			search	: SearchStack,
			branches: BranchesStack,
			status	: StatusStack,
			success	: SuccessScreen,
			failure	: FailureScreen,
			delivery: DeliveryScreen,
			share	: ShareScreen
		},
		{
			initialRouteName: ""
		}
	)	
);

export default class App extends React.Component {
  
	state = {
		showLoading: true,
	}

	globalData = {
		receiptData: undefined,
		color: 'blue'
	}

	constructor(props) {
	  super(props);
	  this.saveData(undefined)
	}

	saveData = async data => {

		if(store.defaultLanguage == 'ar')
		{
			RNI18nManager.forceRTL(true);
			// RN won't set the layout direction if we
			// don't restart the app's JavaScript.
			//Updates.reloadFromCache();
		}

		i18n.translations = translations;
		  // Set the locale once at the beginning of your app.
		i18n.locale = store.defaultLanguage;
	};
	
	render() {
	
		return (
			<AppProvider>
			<MainContainer />
			</AppProvider>
		);
	}
}